import React from 'react';
import cx from 'classnames';
import styled from 'styled-components';
import Progress from 'root/components/Progress/Progress';
import SvgIcon from 'root/components/SvgIcon';
import WithIndicator from 'root/components/withIndicator';
import './Button.scss';

const StyledButton = styled.button
  .withConfig({ shouldForwardProp: (prop) => !['colorName', 'fontSize', 'text', 'textColorName'].includes(prop) })
  .attrs(({ colorName, className, textColorName }) => ({
    className: cx(className, 'BUTTON', 'outline-0 flex-nowrap items-center justify-center pointer fw6', {
      [`bg-${colorName || ''}`]: colorName,
      [`bg-${colorName || ''}-c`]: !textColorName && colorName,
      [`c-${textColorName || ''}`]: textColorName,
    }),
  }))(({ fontSize, text, colorName }) => {
  const styles = {
    // TODO: Try to remove once we get rid of all scss styles
    '&&': {
      // Temporary bump for specificity
      fontSize,
      display: 'inline-flex',
      textOverflow: 'ellipsis',
      border: 'none',
      borderRadius: 4,
      backgroundOrigin: 'border-box',
      paddingTop: 10,
      paddingBottom: 10,
      paddingLeft: !text ? 10 : 16,
      paddingRight: !text ? 10 : 16,
      transition: 'box-shadow 0.3s ease-in-out',
    },
  };

  return colorName
    ? {
        ...styles,
        '&:hover': {
          boxShadow: '0 2px 4px 0 rgba(0, 0, 0, .5)',
        },
        '&:active:hover:enabled': {
          boxShadow: 'inset 0 2px 5px 0 rgba(14, 47, 90, .5)',
        },
        ':disabled': {
          opacity: '0.5',
          pointerEvents: 'none',
        },
      }
    : {
        ...styles,
        ':disabled': {
          opacity: '0.5',
          pointerEvents: 'none',
        },
      };
});

export const Button = ({
  text,
  icon,
  disabled,
  className,
  onClick,
  colorName,
  textColorName,
  textBreakpoint,
  iconSize = 'md',
  fontSize = 14,
  title,
  dataTest,
  inProgress,
  showIndicator,
  ariaLabel,
  tabIndex,
}) => (
  <StyledButton
    {...(dataTest ? { 'data-test': dataTest } : {})}
    disabled={disabled}
    onClick={(e) => {
      if (inProgress) {
        return;
      }
      if (onClick) {
        onClick(e);
      }
    }}
    title={title}
    className={className}
    colorName={colorName}
    textColorName={textColorName}
    text={text}
    fontSize={fontSize}
    test="button"
    aria-label={ariaLabel}
    tabIndex={tabIndex}
  >
    {icon && !inProgress ? (
      <WithIndicator data-test="button-indicator" className="flex align-items-center" showIndicator={showIndicator}>
        <SvgIcon
          size={iconSize}
          path={icon}
          className={cx({
            mr3: !textBreakpoint && text,
            [`mr3-${textBreakpoint || ''}`]: textBreakpoint && text,
            [`fill-bg-${colorName || ''}`]: !textColorName,
            [`fill-${textColorName || ''}`]: textColorName,
          })}
        />
      </WithIndicator>
    ) : null}
    {inProgress ? <Progress size="sm" className="spinner-inside-button" /> : null}
    <span
      className={cx('nowrap', {
        dn: textBreakpoint && text,
        [`db-${textBreakpoint || ''}`]: textBreakpoint && text,
      })}
      data-debug={className}
    >
      {text}
    </span>
  </StyledButton>
);

export default Button;
